import React, { useEffect, useState } from "react";
import { api, timeAgo } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Bell, CheckCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    api.get("/notifications").then(({ data }) => setItems(data.notifications || [])).finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">Activity.</h1>
        <button onClick={markAll} className="brut-btn" data-testid="mark-all-read">
          <CheckCheck size={16} /> Mark all read
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-[var(--cs-ink-2)] font-bold uppercase tracking-widest text-sm">Loading…</div>
      ) : items.length === 0 ? (
        <div className="brut-card p-10 text-center">
          <Bell size={32} className="mx-auto text-[var(--cs-ink-2)]" />
          <div className="font-display text-2xl font-extrabold mt-3">All caught up.</div>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <Link
              key={n.id}
              to={n.task_id ? `/task/${n.task_id}` : "/dashboard"}
              className={`brut-card p-4 flex items-start gap-3 ${!n.read ? "bg-[var(--cs-yellow)]" : ""}`}
              data-testid={`notif-${n.id}`}
            >
              <div className="w-2 h-2 rounded-full mt-2" style={{ background: n.read ? "transparent" : "var(--cs-flame)" }} />
              <div className="flex-1">
                <div className="font-bold">{n.title}</div>
                <div className="text-sm text-[var(--cs-ink-2)]">{n.body}</div>
                <div className="text-[10px] uppercase tracking-widest font-bold text-[var(--cs-ink-2)] mt-1">{timeAgo(n.created_at)}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
